'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var hljs = _interopDefault(require('highlight.js'));

var index = {
  name: 'highlight',
  functional: true,
  props: {
    code: {
      type: String
    },
    language: {
      type: String
    }
  },
  render: function render(h, ctx) {
    var ref = ctx.props;
    var language = ref.language;
    var code = ctx.props.code || ctx.children[0].text;
    var ref$1 = language
      ? hljs.highlight(language, code)
      : hljs.highlightAuto(code);
    var html = ref$1.value;

    return h('pre', ctx.data, [
      h('code', {
        class: 'hljs',
        domProps: {
          innerHTML: html
        }
      })
    ])
  }
};

module.exports = index;
